import { createRequestHelper } from '@utils/swr'
import { type FpCartRequestCacheResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
  mutateAll,
} = createRequestHelper<FortuneApis['get']['cartRequestCache'], FpCartRequestCacheResponse, string | null>({
  client: 'fortune',
  key: campaignCode => campaignCode ? `/campaigns/${campaignCode}/cart_request_cache` : null,
  isImmutable: true,
  mutateAllMatcher: key => key.includes('/cart_request_cache'),
})

export const useApiFpCartRequestCache = useRequest
export const mutateAllFpCartRequestCache = mutateAll
